// SEO Head — inserts <title>, <meta description>, canonical, OG tags,
// and noindex for private routes. Consumes /api/seo/meta for each path.
import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const PRIVATE_PREFIXES = ["/admin", "/dashboard", "/reset-password", "/payment/"];

export default function SeoHead() {
  const { pathname } = useLocation();
  const [meta, setMeta] = React.useState(null);
  const isPrivate = PRIVATE_PREFIXES.some((p) => pathname.startsWith(p));
  React.useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const r = await api.get("/api/seo/meta", { params: { path: pathname } });
        if (alive) setMeta(r.data);
      } catch { /* SEO must never break the app */ }
    })();
    return () => { alive = false; };
  }, [pathname]);
  const robots = isPrivate || meta?.noindex ? "noindex, nofollow" : "index, follow";
  return (
    <Helmet>
      <meta name="robots" content={robots} />
      {meta?.title && <title>{meta.title}</title>}
      {meta?.description && <meta name="description" content={meta.description} />}
      {meta?.canonical && <link rel="canonical" href={meta.canonical} />}
      {meta?.og_title && <meta property="og:title" content={meta.og_title} />}
      {meta?.og_description && <meta property="og:description" content={meta.og_description} />}
      {meta?.og_type && <meta property="og:type" content={meta.og_type} />}
      {meta?.twitter_card && <meta name="twitter:card" content={meta.twitter_card} />}
    </Helmet>
  );
}
